import { C } from '../../constants/colors.js';
import { LEVELS } from '../../constants/levels.js';
import { getLevelName } from '../../config/levelConfig.js';

export function Profiles({profiles, onSelect, onAdd, authUser, onSignIn}) {
  const colors = [C.primary, C.secondary, C.success, C.purple, C.danger, C.accent2, C.accent, '#3FA76A'];
  return (
    <div className="px-6 py-8 text-center">
      <div className="mb-2 text-6xl">📖</div>
      <h2 className="mb-6 font-finley-display text-4xl text-finley-text">Who's reading today?</h2>
      <div className="mx-auto mb-5 flex max-w-sm flex-col gap-3">
        {profiles.map((p,i) => {
          const c = colors[i % colors.length];
          const lv = LEVELS[p.tracker.currentLevel];
          return (
            <button key={p.id} onClick={() => onSelect(p.id)} className="flex items-center gap-4 rounded-finley-xl bg-finley-bg-card px-5 py-4 text-left shadow-finley-md" style={{border:`3px solid ${c}33`}}>
              <div className="flex h-12 w-12 items-center justify-center rounded-finley-lg border-2 font-finley-display text-2xl font-bold" style={{background:`${c}18`,color:c,borderColor:`${c}33`}}>{p.name[0].toUpperCase()}</div>
              <div className="flex-1">
                <div className="font-finley-display text-xl text-finley-text">{p.name}</div>
                <div className="text-sm text-finley-text-light">Age {p.age} • {getLevelName(p.tracker.currentLevel)} ({lv?.name}) • ⭐{p.totalStars}</div>
              </div>
            </button>
          );
        })}
      </div>
      <button onClick={onAdd} className="w-full max-w-sm rounded-finley-lg border-[3px] border-dashed border-finley-text-muted/25 bg-finley-bg px-6 py-4 font-finley-display text-base text-finley-text-light">+ Add Another Child</button>
      {!authUser && onSignIn && (
        <button onClick={onSignIn} className="mx-auto mt-4 block bg-transparent text-sm text-finley-secondary">{"🔗"} Sign in to sync across devices</button>
      )}
    </div>
  );
}
